/*ng2 - update imported services*/
// NOTE: This code is migrated and thus has unknown types
import {Component, Input, Output, OnInit} from '@angular/core';
// TODO: Uncomment FormGroup and its uses when dependency is fixed
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'webu-select-input',
  templateUrl: './select-input.webu.component.html'
})
export class SelectInputWebuComponent implements OnInit{

  @Input() public lov: Array<unknown | string> = [];
  @Input() public lovCode: string;
  @Input() public inputName: string;
  @Input() public lovLabel: string;
  @Input() public required: boolean;
  @Input() public submitted: boolean;
  @Input() public label: string; // cms id to pass into label above dropdown
  @Input() public id: string; // unique identifier to be passed into the select element { important: use data-id attribute to set }
  @Input() public trackValue: string;
  @Input() public customTrackValue: string;
  @Input() public isArray: boolean;
  @Input() public isObjectArray: boolean;
  @Input() public disabled: boolean;
  @Input() public touched: boolean;
  @Input() public isMobileConvertible: boolean;
  @Input() public options: string | Array<string>;
  @Input() public ariaLabel: string;
  @Input() public ariaHasPopup: boolean;
  @Input() public role: string;
  @Input() public tabIndex: number;
  // @Input() public isMobile: boolean;
  @Input() public optionsTranslate: string;
  @Input() public selectInputGroup: FormGroup;
  @Input() public validationType:string;
  public isMobileObserve:boolean;
  private lovCodeFilter = ['\'input[lovCode] as input[lovLabel] for input in lov | filter:filter\''];
  private lovLabelFilter = ['input as input[lovLabel] for input in lov | filter:filter'];
  private lovFilter = ['\'input as input for input in lov | filter:filter\''];
  public hasError = false;

  @Input() public formControlNameInput: string;
  @Input() public formGroupInput:FormGroup;

  // TODO: The original HTML references these functions but they're commented
  // @Output() _change;
  @Output() _focus: () => void;

  @Input()
  set isMobile(isMobile: boolean) { this.isMobileObserve = isMobile; }
  get isMobile() { return this.isMobileObserve; }

  getLabel = (input:any) => {
    if (this.isArray) {
      return input;
    } else {
      return input[this.lovLabel];
    }
  };
  getCode = (input:any) => {
    if (this.isObjectArray || this.isArray) {
      return input;
    } else {
      return input[this.lovCode] as string;
    }
  };

  ngOnInit(): void {
    if (!this.formGroupInput) {
      return;
    }

    if (this.isMobileConvertible) {
      return this._getMobileCodeAndLabel();
    }

    if (!this.options) {
      this._resolveNoOptions();
    } else {
      if (typeof this.options == 'string' && / |\s*cms/i.test(this.options)) this.optionsTranslate = 'true';
    }

  }

  private _resolveNoOptions(){
    this.options = this.lovCodeFilter;
    if (this.isObjectArray) {
      this.options = this.lovLabelFilter;
    } else if (this.isArray) {
      this.options = this.lovFilter;
    }
  }

  private _getMobileCodeAndLabel(){
    // this.getLabel
    //
    // this.getCode(input)
    // this.getCode = (input) => {
    //   if (this.isObjectArray || this.isArray) {
    //     return input;
    //   } else {
    //     return input[this.lovCode];
    //   }
    // };
  }

  public showError() {
    let touched: boolean;
    const checkFormCtrl =
      this.formGroupInput?.controls[this.formControlNameInput];
    if (checkFormCtrl?.touched === undefined) touched = false;
    else {
      touched = checkFormCtrl.touched;
    }
    this.hasError =
      (touched || this.submitted) &&
      checkFormCtrl?.invalid !== undefined &&
      checkFormCtrl.invalid;
    return this.hasError;
  }

  public getOptions(){
    return Array.isArray(this.options) ? this.options : [];
  }

}
